import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const AccessGrantDetailPage = lazy(
  () => import("@/features/dashboard/pages/access-grant-detail"),
);

export const Route = createFileRoute("/(app)/ops/access-grants/$grantPublicId")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading…</div>}>
      <AccessGrantDetailPage />
    </Suspense>
  ),
});
